import * as React from 'react';
import type { MgmtCellClientManager } from '../clients/MgmtCellClientManager';
import { PermissionClaim } from '../code-generated/PermissionClaim.generated';

export type MgmtCellPermissionClaim =
  | PermissionClaim.ReadMaintenance
  | PermissionClaim.ScheduleMaintenance
  | PermissionClaim.ReadSiteAntennaMetrics
  | PermissionClaim.DeviceControlLoopCommanding;

export const MgmtCellClientManagerContext = React.createContext<
  Record<MgmtCellPermissionClaim, MgmtCellClientManager | null>
>({
  [PermissionClaim.ReadMaintenance]: null,
  [PermissionClaim.ScheduleMaintenance]: null,
  [PermissionClaim.ReadSiteAntennaMetrics]: null,
  [PermissionClaim.DeviceControlLoopCommanding]: null,
});

export function useMgmtCellClientManager(permission: MgmtCellPermissionClaim): MgmtCellClientManager | null {
  const clients = React.useContext(MgmtCellClientManagerContext);
  return clients[permission];
}
